import { IDataManager } from './idata_manager';
import { IPhotoDataManager } from '../photo/iphoto_data_manager';
import { AGPhotoManager } from '../photo/ag_photo_data_manager';
import { IAlbumDataManager } from '../album/ialbum_data_manager';
import { AGAlbumManager } from '../album/ag_album_manager';
import { IClientConfig } from './data_manager_factory';
import { IShareDataManager } from '../share/ishare_data_manager';
import { AGShareManager } from '../share/ag_share_manager';
import { UAAccountsManager } from '../accounts/ua_accounts_manager';
import { IAccountsDataManager } from '../accounts/iaccounts_data_managter';

/**
 * Responsible to create and return appropriate view specific manager objects, in Aggregated flow. 
 * @export
 * @class AGDataManager
 * @implements {IDataManager}
 */
export class AGDataManager implements IDataManager {
    private _photoManager: IPhotoDataManager;
    private _albumManager: IAlbumDataManager;
    private _shareManager: IShareDataManager;
    private accountsManager: IAccountsDataManager;
    constructor(config: IClientConfig) {
        this._albumManager = new AGAlbumManager(config);
        this._photoManager = new AGPhotoManager(config);
        this._shareManager = new AGShareManager(config);
        this.accountsManager= new UAAccountsManager(config);
    }
    getPhotoManager(): IPhotoDataManager {
        return this._photoManager;
    }
    getAlbumManager(): IAlbumDataManager {
        return this._albumManager;
    }
    getShareManager(): IShareDataManager {
        return this._shareManager;
    }    
    getAccountsManager(): IAccountsDataManager{
        return this.accountsManager;
    }
}
